import {createContext} from 'react';

export const ErrorHandling = createContext(null);